var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 65.1133C12 77.8437 17.0571 90.0527 26.0589 99.0544C35.0606 108.056 47.2696 113.113 60 113.113C72.7304 113.113 84.9394 108.056 93.9411 99.0544C102.943 90.0527 108 77.8437 108 65.1133C108 52.3829 102.943 40.1739 93.9411 31.1722C84.9394 22.1704 72.7304 17.1133 60 17.1133C47.2696 17.1133 35.0606 22.1704 26.0589 31.1722C17.0571 40.1739 12 52.3829 12 65.1133Z",
    fill: "#F8F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M73.0257 106.32C73.0257 105.385 67.4673 104.627 60.6105 104.627C53.7537 104.627 48.1953 105.385 48.1953 106.32C48.1953 107.255 53.7537 108.013 60.6105 108.013C67.4673 108.013 73.0257 107.26 73.0257 106.32Z",
    fill: "#1E0A3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4004 91.1136C32.4 91.3999 32.4928 91.6786 32.6646 91.9076C32.8365 92.1366 33.0782 92.3035 33.3532 92.3831L59.2168 99.9276C59.4747 100.003 59.7426 100.038 60.0112 100.032V69.0971L32.4004 61.0439V91.1136Z",
    fill: "#F7E5C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.974 79.3776L60.0112 73.3403V69.096L32.4004 61.0439V73.0859L53.974 79.3776Z",
    fill: "#F0D5A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0112 69.0971L32.4004 61.0439L60.0112 52.9907L87.6208 61.1459L60.0112 69.0971Z",
    fill: "#DEBB7E",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0112 69.0971L32.4004 61.0439L60.0112 52.9907V69.0971Z",
    fill: "#B89558",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0117 69.0972V100.032C60.2782 100.027 60.5424 99.9815 60.7953 99.8976L86.7153 91.2576C86.9796 91.1703 87.2096 91.0016 87.3723 90.7758C87.5351 90.5499 87.6222 90.2784 87.6213 90V61.146L60.0117 69.0972Z",
    fill: "#F0D5A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9649 79.3776L87.6213 73.0368L87.6225 61.146L60.0117 69.096V72.5532L65.9649 79.3776Z",
    fill: "#DEBB7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0112 69.0971L32.4004 61.0439V91.1135C32.4 91.3999 32.4928 91.6786 32.6646 91.9076C32.8365 92.1366 33.0782 92.3035 33.3532 92.3831L59.2168 99.9264C59.7335 100.077 60.2839 100.067 60.7948 99.8975L86.7148 91.2575C86.9791 91.1702 87.2091 91.0016 87.3718 90.7757C87.5345 90.5499 87.6217 90.2783 87.6208 89.9999V61.1459L60.0112 69.0971Z",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7325 53.5583C27.5067 53.6165 27.3003 53.7336 27.1345 53.8975C26.9686 54.0614 26.8491 54.2663 26.7881 54.4914C26.7271 54.7164 26.7269 54.9537 26.7874 55.1789C26.8479 55.4041 26.9669 55.6093 27.1325 55.7735L32.4005 61.0439L60.0113 52.9907L52.9649 47.9579C52.6497 47.7323 52.2886 47.5789 51.9074 47.5086C51.5262 47.4383 51.1342 47.4528 50.7593 47.5511L27.7325 53.5583Z",
    fill: "#DEBB7E",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2169 74.8919C53.881 75.228 53.4609 75.4673 53.0006 75.5849C52.5403 75.7025 52.0568 75.6941 51.6009 75.5603L27.6429 68.5716C27.4217 68.508 27.221 68.3877 27.0607 68.2227C26.9003 68.0576 26.7859 67.8535 26.7288 67.6306C26.6717 67.4077 26.6738 67.1737 26.735 66.9518C26.7962 66.73 26.9144 66.528 27.0777 66.3659L32.4009 61.0439L60.0117 69.0971L54.2169 74.8919Z",
    fill: "#F0D5A8",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0117 69.0972V100.032",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.902 53.5743C92.1632 53.6426 92.4016 53.7787 92.5933 53.9688C92.785 54.1589 92.9232 54.3961 92.9938 54.6567C93.0644 54.9172 93.065 55.1918 92.9955 55.4527C92.926 55.7135 92.7889 55.9514 92.598 56.1423L87.6 61.1463L60.0156 53.1063L67.4772 47.7771C67.6597 47.646 67.8688 47.5566 68.0896 47.5152C68.3104 47.4737 68.5376 47.4812 68.7552 47.5371L91.902 53.5743Z",
    fill: "#F0D5A8",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4996 35C47.4996 36.8333 46.5996 41.6 50.9996 46C56.4996 51.5 56.4995 54 54.4995 59",
    stroke: "#1E0A3C",
    strokeWidth: 0.24
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2211 23C65.2211 24.8333 66.1211 29.6 61.7211 34C56.2211 39.5 56.2212 42 58.2212 47",
    stroke: "#1E0A3C",
    strokeWidth: 0.24
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2211 35C73.2211 36.8333 74.1211 41.6 69.7211 46C64.2211 51.5 64.2212 54 66.2212 59",
    stroke: "#1E0A3C",
    strokeWidth: 0.24
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.264 75.4452C66.4585 75.6397 66.7017 75.7782 66.9681 75.8464C67.2346 75.9146 67.5144 75.9099 67.7784 75.8328L92.0052 68.7672C92.2609 68.6927 92.4928 68.5529 92.678 68.3615C92.8632 68.1701 92.9953 67.9338 93.0614 67.6758C93.1274 67.4177 93.125 67.147 93.0545 66.8902C92.984 66.6333 92.8478 66.3993 92.6592 66.2112L87.6 61.146L60.0156 69.186L66.264 75.4452Z",
    fill: "#DEBB7E",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/emptyTable.031f1f14a894ccd33d8668d711ea0733.svg";
export { ForwardRef as ReactComponent };